export const SUBSCRIPTION_PLAN = 'SUBSCRIPTION_PLAN';

export const subscriptionPlan = subscriptionPlan => dispatch =>
  dispatch({
    type: SUBSCRIPTION_PLAN,
    plan: subscriptionPlan
  });
